import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useSubscription } from '@/hooks/useSubscription';
import { Building2, CreditCard, ExternalLink, FileText } from 'lucide-react';

export const BillingManagement = () => {
  const { openBillingPortal, loading } = useSubscription();

  return (
    <Card>
      <CardHeader>
        <CardTitle>Billing</CardTitle>
        <CardDescription>Manage payment methods, company details, and invoices via Stripe.</CardDescription>
      </CardHeader>
      <CardContent className='space-y-3'>
        <div className='rounded-md bg-slate-50 dark:bg-stone-900 divide-y divide-slate-200 dark:divide-stone-800'>
          <div className='flex items-center gap-3 px-3 py-2.5'>
            <CreditCard className='h-4 w-4 text-slate-500 dark:text-stone-400 shrink-0' />
            <span className='text-sm text-slate-700 dark:text-stone-300'>Payment Methods</span>
          </div>
          <div className='flex items-center gap-3 px-3 py-2.5'>
            <Building2 className='h-4 w-4 text-slate-500 dark:text-stone-400 shrink-0' />
            <span className='text-sm text-slate-700 dark:text-stone-300'>Company & VAT</span>
          </div>
          <div className='flex items-center gap-3 px-3 py-2.5'>
            <FileText className='h-4 w-4 text-slate-500 dark:text-stone-400 shrink-0' />
            <span className='text-sm text-slate-700 dark:text-stone-300'>Invoices</span>
          </div>
        </div>
        <Button onClick={openBillingPortal} disabled={loading} className='w-full' variant='outline'>
          <ExternalLink className='h-3.5 w-3.5 mr-2' />
          {loading ? 'Opening...' : 'Open Billing Portal'}
        </Button>
      </CardContent>
    </Card>
  );
};
